import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  type SettingsState,
  type CardBackTheme,
  type TableTheme,
  initialSettingsState,
  toggleSound,
  setSoundVolume,
  toggleHaptics,
  setCardBack,
  setTableTheme,
  toggleAnimations,
  toggleAutoSort,
  toggleConfirmPlay,
  toggleTurnNotifications,
  setLanguage,
  resetSettings,
} from '@callbridge/ui';

interface SettingsActions {
  soundToggled: () => void;
  soundVolumeChanged: (volume: number) => void;
  hapticsToggled: () => void;
  cardBackChanged: (theme: CardBackTheme) => void;
  tableThemeChanged: (theme: TableTheme) => void;
  animationsToggled: () => void;
  autoSortToggled: () => void;
  confirmPlayToggled: () => void;
  turnNotificationsToggled: () => void;
  languageChanged: (lang: string) => void;
  settingsReset: () => void;
}

export type SettingsStore = SettingsState & SettingsActions;

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      ...initialSettingsState,

      soundToggled: () => set((s) => toggleSound(s)),
      soundVolumeChanged: (v) => set((s) => setSoundVolume(s, v)),
      hapticsToggled: () => set((s) => toggleHaptics(s)),
      cardBackChanged: (t) => set((s) => setCardBack(s, t)),
      tableThemeChanged: (t) => set((s) => setTableTheme(s, t)),
      animationsToggled: () => set((s) => toggleAnimations(s)),
      autoSortToggled: () => set((s) => toggleAutoSort(s)),
      confirmPlayToggled: () => set((s) => toggleConfirmPlay(s)),
      turnNotificationsToggled: () => set((s) => toggleTurnNotifications(s)),
      languageChanged: (l) => set((s) => setLanguage(s, l)),
      settingsReset: () => set(() => resetSettings()),
    }),
    { name: 'cb_settings' },
  ),
);
